export default {
  sort: 0,
  path: '/lucky618',
  name: 'lucky618',
  component: () => import('@/views/lucky618/index.vue'),
  hidden: true
}



// WEBPACK FOOTER //
// ./src/router/modules/lucky618.js